"use client";
import e from "react";
e.createContext({
  apiUrl: "",
  baseUrl: "",
  allowPreview: !1,
  previewEnabled: !1,
  setPreviewEnabled: () => {
  },
  notifyBacklink: () => {
  }
});
//# sourceMappingURL=index.es32.js.map
